import {configureStore} from "@reduxjs/toolkit"
import AdminReducer from "./AdminSlice"
import ToastReducer from "./ToastSlice"
import MarketScanReducer from "./MarketScanSlice"

const store = configureStore({
    reducer:{
        admin: AdminReducer,
        toast: ToastReducer,
        marketScan:MarketScanReducer
    }
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store
